import { AppBundle } from 'api/optimalprint-sdk.d';

type ProductItem = AppBundle.Api.Entity.Design.V1.DesignAbstractProduct.DesignProductItem.IProductItem;

const getProductAttributeValue = (product: ProductItem, attributeName: string) => {
  const attributeWithValue = product.attributes?.find((atr) => atr.typeName === attributeName);
  return attributeWithValue ? attributeWithValue.value : undefined;
};

export default getProductAttributeValue;
